<div id="language-switcher">
    <ul>
        <li><a routerLink="/de" (click)="changeLanguage('de')">DE</a></li>
        <li><a routerLink="/en" (click)="changeLanguage('en')">EN</a></li>
    </ul>
</div>